import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const SchoolUniform = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- Form STATE ---------------- */
    const [form, setForm] = useState();

    /* ---------------- TABLE ROWS STATE ---------------- */
    const [uniforms, setUniforms] = useState({
        summer: {
            boys: [{ class_range: "", particulars: "" }],
            girls: [{ class_range: "", particulars: "" }],
        },
        winter: {
            boys: [{ class_range: "", particulars: "" }],
            girls: [{ class_range: "", particulars: "" }],
        },
    });

    /* ---------------- FETCH DATA ---------------- */

    const fetchSection = async () => {
        try {
            setLoading(true);
            const res = await axios.get(
                `${baseAPIUrl}admin/admission_page/get_uniforms/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                setUniforms(res.data.data);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSection();
    }, []);



    /* ---------------- Input Change ---------------- */

    // row handler
    const handleChange = (season, gender, index, field, value) => {
        const updated = { ...uniforms };
        updated[season][gender][index][field] = value;
        setUniforms(updated);
    };

    // + Add Row
    const addRow = (season, gender) => {
        setUniforms({
            ...uniforms,
            [season]: {
                ...uniforms[season],
                [gender]: [
                    ...uniforms[season][gender],
                    { class_range: "", particulars: "" },
                ],
            },
        });
    };

    const deleteRow = (season, gender, index) => {
        if (uniforms[season][gender].length === 1) return;

        const updated = uniforms[season][gender].filter((_, i) => i !== index);

        setUniforms({
            ...uniforms,
            [season]: {
                ...uniforms[season],
                [gender]: updated,
            },
        });
    };


    /* ---------------- Submit ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);

            const formData = new FormData();
            formData.append("school_slug", school_slug);
            formData.append("uniforms", JSON.stringify(uniforms));

            const res = await axios.post(
                `${baseAPIUrl}admin/admission_page/save_uniforms`,
                formData,
                { withCredentials: true }
            );

            setMessage(res.data.msg);
            fetchSection();
            scrollToTop();
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;

    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">School uniform</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">School uniform</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <h4>Edit School uniform</h4>
                                </div>
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div class="card-body">
                                        {message && (
                                            <p className="text-center text-danger">{message}</p>
                                        )}

                                        {/* Uniform Details – Summer */}
                                        <div className="form-group">
                                            <h4>Uniform Details – Summer</h4>

                                            <h5>Boys</h5>
                                            {uniforms.summer.boys.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Class Range"
                                                        value={row.class_range}
                                                        onChange={(e) =>
                                                            handleChange("summer", "boys", index, "class_range", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Uniform Particulars"
                                                        value={row.particulars}
                                                        onChange={(e) =>
                                                            handleChange("summer", "boys", index, "particulars", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("summer", "boys", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("summer", "boys")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>
                                        {/* Uniform Details – Summer */}
                                        <div className="form-group">
                                            <h5>Girls</h5>
                                            {uniforms.summer.girls.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Class Range"
                                                        value={row.class_range}
                                                        onChange={(e) =>
                                                            handleChange("summer", "girls", index, "class_range", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Uniform Particulars"
                                                        value={row.particulars}
                                                        onChange={(e) =>
                                                            handleChange("summer", "girls", index, "particulars", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("summer", "girls", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("summer", "girls")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>

                                        {/* Uniform Details – Winter */}
                                        <div className="form-group">
                                            <h4>Uniform Details – Winter</h4>

                                            <h5>Boys</h5>
                                            {uniforms.winter.boys.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Class Range"
                                                        value={row.class_range}
                                                        onChange={(e) =>
                                                            handleChange("winter", "boys", index, "class_range", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Uniform Particulars"
                                                        value={row.particulars}
                                                        onChange={(e) =>
                                                            handleChange("winter", "boys", index, "particulars", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("winter", "boys", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("winter", "boys")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>
                                        {/* Uniform Details – winter */}
                                        <div className="form-group">
                                            <h5>Girls</h5>
                                            {uniforms.winter.girls.map((row, index) => (
                                                <div key={index} className="d-flex gap-2 mb-2">
                                                    <input
                                                        type="text"
                                                        placeholder="Class Range"
                                                        value={row.class_range}
                                                        onChange={(e) =>
                                                            handleChange("winter", "girls", index, "class_range", e.target.value)
                                                        }
                                                    />

                                                    <input
                                                        type="text"
                                                        placeholder="Uniform Particulars"
                                                        value={row.particulars}
                                                        onChange={(e) =>
                                                            handleChange("winter", "girls", index, "particulars", e.target.value)
                                                        }
                                                    />

                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => deleteRow("winter", "girls", index)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}

                                            <button
                                                type="button"
                                                className="btn btn-success btn-sm"
                                                onClick={() => addRow("winter", "girls")}
                                            >
                                                + Add Row
                                            </button>
                                        </div>
                                    </div>

                                    <div className="card-footer">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            disabled={loading}
                                        >
                                            {loading ? "Submitting..." : "Submit"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}
export default SchoolUniform;